// Document Library — the screen's strings in the portal's four languages (2026-10-21).
// "Catchy" / "E-Docs" are names and stay as they are in every language (task #105, 30/10).
const en = {
  catchyOnBy: "On for Catchy: {{by}}, {{when}}",
  upHelpNewVer: "A new version of a document already here? Open that document and press Upload New version — not New document.",
  upHelpKind: "Required. What the document is (manual, SOP, policy, form…). It sets the code the Portal gives it.",
  upHelpTitle: "The name only — no date or version in it (the Portal keeps those).",
  upHelpFolder: "The team folder it belongs to, e.g. HEVN Operational › Admin. The folder's owner then switches it on for Catchy.",
  upHelpVersionNew: "Leave it empty for v1.0, unless the file itself states its version.",
  upHelpVersion: "Leave it empty and the Portal counts on from the last version, or type the version the file states.",
  audTitle: "Who Catchy shares it with",
  audAll: "All staff",
  audReaders: "People who can open it in E-Docs",
  audLimited: "Selected roles and departments",
  audAdmins: "Admins always",
  audDepts: "Departments",
  audRoles: "Roles",
  audSetBy: "set by {{by}}, {{when}}",
  audEdit: "Who can see it",
  audSave: "Save",
  audHint: "Catchy uses this document only for the people chosen here. Anybody else who asks is told Catchy cannot share that information.",
  audDefaultCosting: "Default for the Costing folder: the Costing department and the Costing and CEO roles.",
  audDefaultRule: "Default: the document's own reading rule in E-Docs.",
  audPickOne: "Pick at least one role or department.",
  audSaved: "Saved — Catchy shares it with: {{who}}",
  catchyWarnAud: "Catchy will answer from this document for the people chosen below — also for people who cannot open it here. You can change this or switch it off at any time.",
  audLine: "Catchy shares it with: {{who}}",
  aiNoteReview: "written by AI — read it and correct it before uploading",
  aiReading: "AI is reading the file and comparing it with the current version…",
  aiNotePh: "AI writes this line when you choose the file — or type your own",
  aiWriting: "Uploading — AI is writing what changed…",
  aiNoteTitle: "Written by AI from the two versions — edit it if it misses something",
  aiNoteEdit: "written by AI — correct it here if needed",
  failed: "Failed ({{status}})",
  readFileFailed: "Could not read that file",
  titlePlaceholder: "Operating Handbook",
  catchyBadge: "Catchy",
  catchyBadgeTitle: "Catchy reads this document",
  catchyWaitingBadge: "new version waiting",
  catchyOffState: "Catchy does not read this document for all staff (it still answers from it for people who may open it here).",
  catchyLive: "Catchy reads {{version}} — switched on by {{by}}, {{when}}",
  catchyWaiting: "{{current}} is waiting: Catchy still reads {{live}} until an owner of the folder switches the new version on.",
  catchyActivate: "Activate for Catchy",
  catchyActivateNew: "Switch {{version}} on for Catchy",
  catchyDeactivate: "Switch off for Catchy",
  catchyWarnTitle: "Activate for Catchy?",
  catchyWarn: "This content will be available to all staff through Catchy — also to people who cannot open this document here. You can switch it off at any time.",
  catchyOffTitle: "Switch off for Catchy?",
  catchyOffBody: "Catchy stops reading this document at once. The document itself stays as it is.",
  catchyOnMsg: "Catchy now reads {{version}} ({{n}} passages) for the people it is shared with.",
  catchyOffMsg: "Catchy no longer reads this document.",
  catchyUploadWaiting: "Uploaded. Catchy keeps reading the previous version until an owner of the folder switches this one on.",
  catchyUploadUnreadable: "Uploaded — but Catchy cannot read text from this file, so it keeps reading the previous version.",
  catchyUploadLive: "Uploaded — Catchy now reads the new version.",
  catchyList: "Catchy knowledge",
  catchyListHint: "Every document Catchy reads, who it is shared with, who switched it on and when. Folder owners and Admins switch documents on and choose who Catchy shares them with on the document page.",
  catchyNone: "No document is switched on for Catchy yet.",
  colFolder: "Folder",
  colLive: "Catchy reads",
  colBy: "Switched on by",
  colWhen: "When",
  owners: "Owners",
  ownersOf: "Owners of {{name}}",
  ownersHint: "Owners switch this folder's documents on for Catchy, and only they (and Admins) rename or remove the folder or add sub-folders. Sub-folders inherit them.",
  ownersInherited: "Also owners, from folders above: {{names}}",
  ownersSearch: "Search a name",
  ownersSave: "Save owners",
  ownersLine: "Owners: {{names}}",
  // Kind filter and several-at-once Catchy (Jay tasks #1117 / #1120, 31/10)
  kindAll: "All kinds",
  bulkSelected: "{{n}} selected",
  bulkOn: "Switch on for Catchy",
  bulkOff: "Switch off for Catchy",
  bulkClear: "Clear",
  bulkAll: "Select all shown that you can switch",
  bulkNotYours: "Only the owners of this folder and Admins can switch this one",
  bulkOnTitle: "Switch {{n}} document(s) on for Catchy?",
  bulkOffTitle: "Switch {{n}} document(s) off for Catchy?",
  bulkWill: "Will be switched",
  bulkSkip: "Skipped",
  bulkNone: "None of the selected documents can be switched.",
  bulkDoneOn: "Switched on for Catchy: {{n}}.",
  bulkDoneOff: "Switched off for Catchy: {{n}}.",
  bulkSkipped: "Skipped {{n}}: {{list}}.",
  skip_folder: "not your folder",
  skip_noversion: "no version uploaded",
  skip_on: "already on",
  skip_off: "already off",
  skip_missing: "not found",
  langsDiffer: 'Pick a different language for each file.',
  langBar: 'Language of the document',
  sideBySide: 'Side by side',
  fileN: 'File {{n}}',
  leftLang: 'Language on the left',
  rightLang: 'Language on the right',
  mainFile: 'main',
  langOf: 'Language of {{name}}',
  langReading: 'Reading…',
  langPick: 'Pick the language',
  howText: 'read from the text',
  howName: 'from the file name',
  removeFile: 'Remove {{name}}',
  addLangFile: 'Add another language',
  pickFiles: 'Choose file(s)',
  langNote: "Up to 8 files, 30 MB each, in the portal's languages: Tiếng Việt, English, 한국어, 中文. Two files in the same language become parts of the document, read as tabs. The language is read from each file; check it before uploading. The first file is the main one.",
  langsMissing: 'Pick the language of every file.',
  langFileFailed: 'Version {{label}} was saved, but {{name}} could not be added: {{error}}',
  download: 'Download',
  downloadTitle: 'Download the version and language on screen — the copy says its version and to check HEVN Portal for the latest',
  downloaded: 'Downloaded',
  tooBig: "{{name}} is {{mb}} MB — the limit is {{max}} MB a file.",
  serverTooBig: "The file is too large for the server — the limit is {{mb}} MB a file.",
  partN: "Part {{n}}",
  partsNote: "{{n}} files in {{lang}}: they become parts of the document, read as tabs.",
  partBar: "Parts of the document",
  addFile: "Add another file",
  kindChange: "Change to {{code}}",
  kindHint: "{{old}} gets the next code of the new kind ({{code}}); {{old}} and its links keep opening it. Everybody it was shared with gets an email and a bell.",
  kindChanged: "Kind changed: {{old}} is now {{code}}. {{n}} people it was shared with were told.",
  formerly: "formerly {{codes}}",
  kindChoose: "Choose a kind",
  authorChoose: "Choose the author",
  fixVersion: "Version",
  fixVersionHint: "The current version's number, as the document states it (e.g. v2.1). The next upload counts on from it.",
  kindAbout_HB: "Handbook — how the company works: rules and ways of working everybody should know.",
  kindAbout_GTM: "Framework — a model or framework, e.g. go-to-market.",
  kindAbout_CAT: "Categories — how products or items are grouped and classified.",
  kindAbout_ANN: "Announcement — a dated notice to staff.",
  kindAbout_POL: "Policy — rules that must be followed: what is allowed, who decides.",
  kindAbout_SOP: "SOP — a step-by-step procedure for one task.",
  kindAbout_MAN: "Manual & Instruction — how a system, a tool or a product works.",
  kindAbout_RPT: "Report — findings or figures for a period.",
  kindAbout_FRM: "Form & Template — a blank to fill in.",
  kindAbout_DOC: "Other — only when none of the kinds above fits.",
  folderChoose: "Choose a folder",
};
const ko = {
  catchyOnBy: "Catchy 켬: {{by}}, {{when}}",
  upHelpNewVer: "이미 있는 문서의 새 버전인가요? 그 문서를 열고 Upload New version을 누르세요 — New document가 아닙니다.",
  upHelpKind: "필수. 문서의 종류(매뉴얼, SOP, 정책, 양식…). 포털이 부여하는 코드가 이것으로 정해집니다.",
  upHelpTitle: "이름만 — 날짜나 버전은 넣지 마세요(포털이 관리합니다).",
  upHelpFolder: "문서가 속한 팀 폴더, 예: HEVN Operational › Admin. 이후 폴더 소유자가 Catchy에 켭니다.",
  upHelpVersionNew: "파일에 버전이 적혀 있지 않으면 비워 두세요(v1.0).",
  upHelpVersion: "비워 두면 포털이 이전 버전에서 이어서 매깁니다. 파일에 적힌 버전이 있으면 그것을 입력하세요.",
  audTitle: "Catchy 공유 대상",
  audAll: "전 직원",
  audReaders: "E-Docs에서 이 문서를 열 수 있는 사람",
  audLimited: "선택한 역할 및 부서",
  audAdmins: "Admin은 항상 포함",
  audDepts: "부서",
  audRoles: "역할",
  audSetBy: "{{by}} 님이 설정, {{when}}",
  audEdit: "공유 대상",
  audSave: "저장",
  audHint: "Catchy는 여기서 선택한 사람에게만 이 문서를 사용합니다. 그 외의 사람이 물으면 해당 정보는 공유할 수 없다고 답합니다.",
  audDefaultCosting: "Costing 폴더 기본값: Costing 부서와 Costing·CEO 역할.",
  audDefaultRule: "기본값: E-Docs에서 이 문서의 열람 규칙.",
  audPickOne: "역할 또는 부서를 하나 이상 선택하세요.",
  audSaved: "저장했습니다 — Catchy 공유 대상: {{who}}",
  catchyWarnAud: "아래에서 선택한 사람에게 Catchy가 이 문서로 답변합니다 — 여기서 이 문서를 열 수 없는 사람도 포함됩니다. 언제든 변경하거나 끌 수 있습니다.",
  audLine: "Catchy 공유 대상: {{who}}",
  aiNoteReview: "AI 작성 — 업로드 전에 읽고 필요하면 수정하세요",
  aiReading: "AI가 파일을 읽고 현재 버전과 비교하고 있습니다…",
  aiNotePh: "파일을 고르면 AI가 이 줄을 작성합니다 — 직접 입력해도 됩니다",
  aiWriting: "업로드 중 — AI가 변경 내용을 작성하고 있습니다…",
  aiNoteTitle: "두 버전을 비교해 AI가 작성 — 빠진 내용이 있으면 수정하세요",
  aiNoteEdit: "AI 작성 — 필요하면 여기서 수정",
  failed: "실패 ({{status}})",
  readFileFailed: "해당 파일을 읽을 수 없습니다",
  titlePlaceholder: "운영 핸드북",
  catchyBadge: "Catchy",
  catchyBadgeTitle: "Catchy가 이 문서를 읽습니다",
  catchyWaitingBadge: "새 버전 대기 중",
  catchyOffState: "Catchy는 이 문서를 전 직원용으로 읽지 않습니다 (여기서 열 수 있는 사람에게는 계속 답합니다).",
  catchyLive: "Catchy가 {{version}}을(를) 읽습니다 — {{by}} 님이 켬, {{when}}",
  catchyWaiting: "{{current}} 대기 중: 폴더 소유자가 새 버전을 켤 때까지 Catchy는 계속 {{live}}을(를) 읽습니다.",
  catchyActivate: "Catchy에 활성화",
  catchyActivateNew: "{{version}}을(를) Catchy에 켜기",
  catchyDeactivate: "Catchy에서 끄기",
  catchyWarnTitle: "Catchy에 활성화할까요?",
  catchyWarn: "이 내용은 Catchy를 통해 전 직원이 볼 수 있게 됩니다 — 여기서 이 문서를 열 수 없는 사람도 포함됩니다. 언제든 끌 수 있습니다.",
  catchyOffTitle: "Catchy에서 끌까요?",
  catchyOffBody: "Catchy가 이 문서를 즉시 읽지 않습니다. 문서 자체는 그대로 남습니다.",
  catchyOnMsg: "이제 Catchy가 공유 대상을 위해 {{version}}({{n}}개 구간)을 읽습니다.",
  catchyOffMsg: "Catchy가 더 이상 이 문서를 읽지 않습니다.",
  catchyUploadWaiting: "업로드했습니다. 폴더 소유자가 이 버전을 켤 때까지 Catchy는 이전 버전을 계속 읽습니다.",
  catchyUploadUnreadable: "업로드했지만 Catchy가 이 파일에서 텍스트를 읽을 수 없어 이전 버전을 계속 읽습니다.",
  catchyUploadLive: "업로드했습니다 — 이제 Catchy가 새 버전을 읽습니다.",
  catchyList: "Catchy 지식",
  catchyListHint: "Catchy가 읽는 모든 문서와 공유 대상, 누가 언제 켰는지. 폴더 소유자와 Admin이 문서 페이지에서 켜고 공유 대상을 정합니다.",
  catchyNone: "아직 Catchy에 켜진 문서가 없습니다.",
  colFolder: "폴더",
  colLive: "Catchy가 읽는 버전",
  colBy: "켠 사람",
  colWhen: "일시",
  owners: "소유자",
  ownersOf: "{{name}} 소유자",
  ownersHint: "소유자는 이 폴더의 문서를 Catchy에 켜며, 소유자(와 Admin)만 폴더 이름 변경·삭제·하위 폴더 추가를 할 수 있습니다. 하위 폴더는 소유자를 물려받습니다.",
  ownersInherited: "상위 폴더의 소유자: {{names}}",
  ownersSearch: "이름 검색",
  ownersSave: "소유자 저장",
  ownersLine: "소유자: {{names}}",
  // Kind filter and several-at-once Catchy (Jay tasks #1117 / #1120, 31/10)
  kindAll: "모든 종류",
  bulkSelected: "{{n}}개 선택",
  bulkOn: "Catchy에 켜기",
  bulkOff: "Catchy에서 끄기",
  bulkClear: "선택 해제",
  bulkAll: "켜고 끌 수 있는 문서 모두 선택",
  bulkNotYours: "이 폴더의 소유자와 관리자만 켜고 끌 수 있습니다",
  bulkOnTitle: "문서 {{n}}개를 Catchy에 켤까요?",
  bulkOffTitle: "문서 {{n}}개를 Catchy에서 끌까요?",
  bulkWill: "적용 대상",
  bulkSkip: "제외",
  bulkNone: "선택한 문서 중 켜거나 끌 수 있는 문서가 없습니다.",
  bulkDoneOn: "Catchy에 켬: {{n}}개.",
  bulkDoneOff: "Catchy에서 끔: {{n}}개.",
  bulkSkipped: "{{n}}개 제외: {{list}}.",
  skip_folder: "내 폴더 아님",
  skip_noversion: "업로드된 버전 없음",
  skip_on: "이미 켜짐",
  skip_off: "이미 꺼짐",
  skip_missing: "찾을 수 없음",
  langsDiffer: '파일마다 다른 언어를 고르세요.',
  langBar: '문서 언어',
  sideBySide: '나란히 보기',
  fileN: '파일 {{n}}',
  leftLang: '왼쪽 언어',
  rightLang: '오른쪽 언어',
  mainFile: '기본',
  langOf: '{{name}}의 언어',
  langReading: '읽는 중…',
  langPick: '언어 선택',
  howText: '본문에서 읽음',
  howName: '파일 이름에서',
  removeFile: '{{name}} 빼기',
  addLangFile: '다른 언어 추가',
  pickFiles: '파일 선택',
  langNote: "최대 8개 파일, 파일당 30MB, 포털 언어만: Tiếng Việt, English, 한국어, 中文. 같은 언어 파일 두 개는 문서의 파트가 되어 탭으로 읽습니다. 언어는 파일 내용에서 읽으니 업로드 전에 확인하세요. 첫 번째 파일이 기본 파일입니다.",
  langsMissing: '모든 파일의 언어를 고르세요.',
  langFileFailed: '{{label}} 버전은 저장되었지만 {{name}} 파일은 추가하지 못했습니다: {{error}}',
  download: '다운로드',
  downloadTitle: '화면의 버전과 언어를 다운로드합니다 — 사본에 버전과 "최신 버전은 HEVN Portal 확인" 문구가 들어갑니다',
  downloaded: '다운로드',
  tooBig: "{{name}}은(는) {{mb}}MB입니다 — 파일당 한도는 {{max}}MB입니다.",
  serverTooBig: "파일이 서버 한도를 넘습니다 — 파일당 {{mb}}MB까지입니다.",
  partN: "파트 {{n}}",
  partsNote: "{{lang}} 파일 {{n}}개: 문서의 파트가 되어 탭으로 읽습니다.",
  partBar: "문서 파트",
  addFile: "파일 추가",
  kindChange: "{{code}}(으)로 변경",
  kindHint: "{{old}}에 새 종류의 다음 코드({{code}})가 부여됩니다. {{old}}와 기존 링크로도 계속 열립니다. 공유받은 모든 사람에게 이메일과 알림이 갑니다.",
  kindChanged: "종류 변경: {{old}} → {{code}}. 공유받은 {{n}}명에게 알렸습니다.",
  formerly: "이전 코드 {{codes}}",
  kindChoose: "종류를 선택하세요",
  authorChoose: "작성자를 선택하세요",
  fixVersion: "버전",
  fixVersionHint: "문서에 적힌 현재 버전 번호(예: v2.1). 다음 업로드는 이 번호에서 이어집니다.",
  kindAbout_HB: "핸드북 — 회사가 일하는 방식: 모두가 알아야 할 규칙과 업무 방식.",
  kindAbout_GTM: "프레임워크 — 모델 또는 프레임워크(예: GTM).",
  kindAbout_CAT: "카테고리 — 제품·항목의 분류 기준.",
  kindAbout_ANN: "공지 — 날짜가 있는 직원 공지.",
  kindAbout_POL: "정책 — 반드시 지켜야 할 규칙: 허용 범위와 결정권자.",
  kindAbout_SOP: "SOP — 한 가지 업무의 단계별 절차.",
  kindAbout_MAN: "매뉴얼·지침 — 시스템, 도구 또는 제품의 사용 방법.",
  kindAbout_RPT: "보고서 — 일정 기간의 결과나 수치.",
  kindAbout_FRM: "양식·템플릿 — 작성용 빈 양식.",
  kindAbout_DOC: "기타 — 위 종류에 맞는 것이 없을 때만.",
  folderChoose: "폴더를 선택하세요",
};
const vi = {
  catchyOnBy: "Bật cho Catchy: {{by}}, {{when}}",
  upHelpNewVer: "Là phiên bản mới của tài liệu đã có? Mở tài liệu đó và bấm Upload New version — không dùng New document.",
  upHelpKind: "Bắt buộc. Loại tài liệu (manual, SOP, policy, form…). Portal cấp mã theo loại này.",
  upHelpTitle: "Chỉ ghi tên — không ghi ngày hay phiên bản (Portal tự giữ).",
  upHelpFolder: "Folder của team mà tài liệu thuộc về, vd HEVN Operational › Admin. Sau đó owner của folder bật cho Catchy.",
  upHelpVersionNew: "Để trống là v1.0, trừ khi trong file có ghi phiên bản.",
  upHelpVersion: "Để trống thì Portal đánh tiếp từ phiên bản trước, hoặc gõ phiên bản ghi trong file.",
  audTitle: "Catchy chia sẻ cho ai",
  audAll: "Toàn bộ nhân viên",
  audReaders: "Người mở được tài liệu này trong E-Docs",
  audLimited: "Role và department được chọn",
  audAdmins: "Admin luôn có",
  audDepts: "Department",
  audRoles: "Role",
  audSetBy: "{{by}} đặt lúc {{when}}",
  audEdit: "Ai được xem",
  audSave: "Lưu",
  audHint: "Catchy chỉ dùng tài liệu này cho những người được chọn ở đây. Người khác hỏi thì Catchy trả lời là không chia sẻ được thông tin đó.",
  audDefaultCosting: "Mặc định của folder Costing: department Costing và role Costing, CEO.",
  audDefaultRule: "Mặc định: theo quyền đọc của tài liệu trong E-Docs.",
  audPickOne: "Chọn ít nhất một role hoặc department.",
  audSaved: "Đã lưu — Catchy chia sẻ cho: {{who}}",
  catchyWarnAud: "Catchy sẽ trả lời từ tài liệu này cho những người được chọn bên dưới — kể cả người không mở được tài liệu này ở đây. Có thể đổi hoặc tắt bất cứ lúc nào.",
  audLine: "Catchy chia sẻ cho: {{who}}",
  aiNoteReview: "do AI viết — đọc và sửa trước khi upload nếu cần",
  aiReading: "AI đang đọc file và so với bản hiện tại…",
  aiNotePh: "Chọn file là AI viết dòng này — hoặc tự gõ",
  aiWriting: "Đang upload — AI đang viết phần thay đổi…",
  aiNoteTitle: "AI viết từ việc so hai bản — sửa lại nếu còn thiếu",
  aiNoteEdit: "do AI viết — sửa ở đây nếu cần",
  failed: "Không thành công ({{status}})",
  readFileFailed: "Không đọc được tệp đó",
  titlePlaceholder: "Sổ tay vận hành",
  catchyBadge: "Catchy",
  catchyBadgeTitle: "Catchy đọc tài liệu này",
  catchyWaitingBadge: "có bản mới đang chờ",
  catchyOffState: "Catchy chưa đọc tài liệu này cho toàn bộ nhân viên (vẫn trả lời từ nó cho người mở được tài liệu ở đây).",
  catchyLive: "Catchy đọc {{version}} — {{by}} bật lúc {{when}}",
  catchyWaiting: "{{current}} đang chờ: Catchy vẫn đọc {{live}} cho tới khi owner của folder bật bản mới.",
  catchyActivate: "Bật cho Catchy",
  catchyActivateNew: "Bật {{version}} cho Catchy",
  catchyDeactivate: "Tắt cho Catchy",
  catchyWarnTitle: "Bật cho Catchy?",
  catchyWarn: "Nội dung này sẽ đến được với toàn bộ nhân viên qua Catchy — kể cả người không mở được tài liệu này ở đây. Có thể tắt bất cứ lúc nào.",
  catchyOffTitle: "Tắt cho Catchy?",
  catchyOffBody: "Catchy thôi đọc tài liệu này ngay. Bản thân tài liệu vẫn giữ nguyên.",
  catchyOnMsg: "Catchy đang đọc {{version}} ({{n}} đoạn) cho những người được chia sẻ.",
  catchyOffMsg: "Catchy không đọc tài liệu này nữa.",
  catchyUploadWaiting: "Đã upload. Catchy vẫn đọc bản trước cho tới khi owner của folder bật bản này.",
  catchyUploadUnreadable: "Đã upload — nhưng Catchy không đọc được chữ trong file này nên vẫn đọc bản trước.",
  catchyUploadLive: "Đã upload — Catchy đang đọc bản mới.",
  catchyList: "Kiến thức của Catchy",
  catchyListHint: "Mọi tài liệu Catchy đọc, chia sẻ cho ai, ai bật và lúc nào. Owner của folder và Admin bật và chọn người được chia sẻ ở trang tài liệu.",
  catchyNone: "Chưa có tài liệu nào được bật cho Catchy.",
  colFolder: "Folder",
  colLive: "Catchy đọc",
  colBy: "Người bật",
  colWhen: "Lúc",
  owners: "Owner",
  ownersOf: "Owner của {{name}}",
  ownersHint: "Owner bật tài liệu của folder này cho Catchy, và chỉ owner (cùng Admin) mới đổi tên, xoá folder hay thêm folder con. Folder con thừa hưởng owner.",
  ownersInherited: "Owner từ folder phía trên: {{names}}",
  ownersSearch: "Tìm tên",
  ownersSave: "Lưu owner",
  ownersLine: "Owner: {{names}}",
  // Kind filter and several-at-once Catchy (Jay tasks #1117 / #1120, 31/10)
  kindAll: "Tất cả loại",
  bulkSelected: "Đã chọn {{n}}",
  bulkOn: "Bật cho Catchy",
  bulkOff: "Tắt cho Catchy",
  bulkClear: "Bỏ chọn",
  bulkAll: "Chọn tất cả tài liệu bạn được bật/tắt",
  bulkNotYours: "Chỉ chủ thư mục này và Admin mới bật/tắt được",
  bulkOnTitle: "Bật {{n}} tài liệu cho Catchy?",
  bulkOffTitle: "Tắt {{n}} tài liệu cho Catchy?",
  bulkWill: "Sẽ áp dụng",
  bulkSkip: "Bỏ qua",
  bulkNone: "Không có tài liệu nào trong số đã chọn bật/tắt được.",
  bulkDoneOn: "Đã bật cho Catchy: {{n}}.",
  bulkDoneOff: "Đã tắt cho Catchy: {{n}}.",
  bulkSkipped: "Bỏ qua {{n}}: {{list}}.",
  skip_folder: "không phải thư mục của bạn",
  skip_noversion: "chưa có phiên bản",
  skip_on: "đã bật sẵn",
  skip_off: "đã tắt sẵn",
  skip_missing: "không tìm thấy",
  langsDiffer: 'Chọn ngôn ngữ khác nhau cho mỗi file.',
  langBar: 'Ngôn ngữ của tài liệu',
  sideBySide: 'Xem song song',
  fileN: 'File {{n}}',
  leftLang: 'Ngôn ngữ bên trái',
  rightLang: 'Ngôn ngữ bên phải',
  mainFile: 'chính',
  langOf: 'Ngôn ngữ của {{name}}',
  langReading: 'Đang đọc…',
  langPick: 'Chọn ngôn ngữ',
  howText: 'đọc từ nội dung',
  howName: 'theo tên file',
  removeFile: 'Bỏ {{name}}',
  addLangFile: 'Thêm ngôn ngữ khác',
  pickFiles: 'Chọn file',
  langNote: "Tối đa 8 file, mỗi file 30 MB, theo các ngôn ngữ của portal: Tiếng Việt, English, 한국어, 中文. Hai file cùng ngôn ngữ sẽ thành các phần của tài liệu, đọc theo tab. Ngôn ngữ được đọc từ nội dung file; kiểm tra lại trước khi upload. File đầu tiên là file chính.",
  langsMissing: 'Chọn ngôn ngữ cho mọi file.',
  langFileFailed: 'Bản {{label}} đã lưu, nhưng chưa thêm được {{name}}: {{error}}',
  download: 'Tải về',
  downloadTitle: 'Tải bản và ngôn ngữ đang xem — bản tải về ghi số phiên bản và dòng nhắc xem bản mới nhất trên HEVN Portal',
  downloaded: 'Đã tải',
  tooBig: "{{name}} nặng {{mb}} MB — giới hạn là {{max}} MB mỗi file.",
  serverTooBig: "File quá lớn so với giới hạn của server — tối đa {{mb}} MB mỗi file.",
  partN: "Phần {{n}}",
  partsNote: "{{n}} file {{lang}}: sẽ thành các phần của tài liệu, đọc theo tab.",
  partBar: "Các phần của tài liệu",
  addFile: "Thêm file",
  kindChange: "Đổi sang {{code}}",
  kindHint: "{{old}} sẽ nhận mã tiếp theo của loại mới ({{code}}); mã {{old}} và các link cũ vẫn mở được. Mọi người đã được share sẽ nhận email và thông báo chuông.",
  kindChanged: "Đã đổi loại: {{old}} giờ là {{code}}. Đã báo cho {{n}} người được share.",
  formerly: "mã cũ {{codes}}",
  kindChoose: "Chọn loại tài liệu",
  authorChoose: "Chọn tác giả",
  fixVersion: "Phiên bản",
  fixVersionHint: "Số phiên bản hiện tại, đúng như tài liệu ghi (ví dụ v2.1). Lần upload sau sẽ nối tiếp từ số này.",
  kindAbout_HB: "Handbook — cách công ty vận hành: quy định và cách làm việc mọi người cần biết.",
  kindAbout_GTM: "Framework — một mô hình hoặc khung, ví dụ go-to-market.",
  kindAbout_CAT: "Categories — cách phân nhóm, phân loại sản phẩm hoặc hạng mục.",
  kindAbout_ANN: "Announcement — thông báo gửi nhân viên, có ngày.",
  kindAbout_POL: "Policy — quy định bắt buộc tuân thủ: được phép gì, ai quyết định.",
  kindAbout_SOP: "SOP — quy trình từng bước cho một công việc.",
  kindAbout_MAN: "Manual & Instruction — cách dùng một hệ thống, công cụ hoặc sản phẩm.",
  kindAbout_RPT: "Report — kết quả hoặc số liệu của một giai đoạn.",
  kindAbout_FRM: "Form & Template — mẫu trống để điền.",
  kindAbout_DOC: "Other — chỉ dùng khi không loại nào ở trên phù hợp.",
  folderChoose: "Chọn thư mục",
};
const zh = {
  catchyOnBy: "Catchy 已开启：{{by}}，{{when}}",
  upHelpNewVer: "是已有文件的新版本？请打开该文件并点击 Upload New version，而不是 New document。",
  upHelpKind: "必填。文件类型（手册、SOP、政策、表单…），Portal 据此分配编号。",
  upHelpTitle: "只写名称，不要写日期或版本（由 Portal 管理）。",
  upHelpFolder: "文件所属的团队文件夹，例如 HEVN Operational › Admin。之后由文件夹负责人为 Catchy 开启。",
  upHelpVersionNew: "文件本身未写版本时留空（v1.0）。",
  upHelpVersion: "留空则 Portal 从上一版本继续编号，或填写文件中写明的版本。",
  audTitle: "Catchy 共享对象",
  audAll: "全体员工",
  audReaders: "在 E-Docs 中能打开此文件的人",
  audLimited: "选定的角色和部门",
  audAdmins: "Admin 始终包含",
  audDepts: "部门",
  audRoles: "角色",
  audSetBy: "由 {{by}} 设置，{{when}}",
  audEdit: "谁可以看",
  audSave: "保存",
  audHint: "Catchy 只为这里选定的人使用此文件。其他人询问时，Catchy 会说无法分享该信息。",
  audDefaultCosting: "Costing 文件夹默认：Costing 部门及 Costing、CEO 角色。",
  audDefaultRule: "默认：此文件在 E-Docs 中的阅读规则。",
  audPickOne: "请至少选择一个角色或部门。",
  audSaved: "已保存 — Catchy 共享对象：{{who}}",
  catchyWarnAud: "Catchy 将为下方选定的人使用此文件回答 — 包括在此无法打开该文件的人。可随时更改或关闭。",
  audLine: "Catchy 共享对象：{{who}}",
  aiNoteReview: "AI 填写 — 上传前请阅读，如有需要请修改",
  aiReading: "AI 正在读取文件并与当前版本比较…",
  aiNotePh: "选择文件后 AI 会填写此行 — 也可自行输入",
  aiWriting: "上传中 — AI 正在填写变更内容…",
  aiNoteTitle: "由 AI 比较两个版本后填写 — 如有遗漏请修改",
  aiNoteEdit: "AI 填写 — 如需可在此修改",
  failed: "失败（{{status}}）",
  readFileFailed: "无法读取该文件",
  titlePlaceholder: "运营手册",
  catchyBadge: "Catchy",
  catchyBadgeTitle: "Catchy 读取此文件",
  catchyWaitingBadge: "新版本待开启",
  catchyOffState: "Catchy 未为全体员工读取此文件（对可在此打开它的人仍会据此回答）。",
  catchyLive: "Catchy 读取 {{version}} — 由 {{by}} 于 {{when}} 开启",
  catchyWaiting: "{{current}} 待开启：在文件夹负责人开启新版本之前，Catchy 仍读取 {{live}}。",
  catchyActivate: "为 Catchy 开启",
  catchyActivateNew: "为 Catchy 开启 {{version}}",
  catchyDeactivate: "为 Catchy 关闭",
  catchyWarnTitle: "为 Catchy 开启？",
  catchyWarn: "开启后，全体员工都可通过 Catchy 获取此内容 — 包括在此无法打开该文件的人。可随时关闭。",
  catchyOffTitle: "为 Catchy 关闭？",
  catchyOffBody: "Catchy 将立即停止读取此文件。文件本身保持不变。",
  catchyOnMsg: "Catchy 现为共享对象读取 {{version}}（{{n}} 段）。",
  catchyOffMsg: "Catchy 不再读取此文件。",
  catchyUploadWaiting: "已上传。在文件夹负责人开启此版本之前，Catchy 仍读取上一版本。",
  catchyUploadUnreadable: "已上传 — 但 Catchy 无法从此文件读取文字，因此仍读取上一版本。",
  catchyUploadLive: "已上传 — Catchy 现读取新版本。",
  catchyList: "Catchy 知识",
  catchyListHint: "Catchy 读取的所有文件、共享对象，以及由谁、何时开启。文件夹负责人和 Admin 在文件页面开启并选择共享对象。",
  catchyNone: "尚无为 Catchy 开启的文件。",
  colFolder: "文件夹",
  colLive: "Catchy 读取",
  colBy: "开启人",
  colWhen: "时间",
  owners: "负责人",
  ownersOf: "{{name}} 的负责人",
  ownersHint: "负责人为 Catchy 开启此文件夹中的文件；只有负责人（及 Admin）可以重命名、删除文件夹或添加子文件夹。子文件夹继承负责人。",
  ownersInherited: "上级文件夹的负责人：{{names}}",
  ownersSearch: "搜索姓名",
  ownersSave: "保存负责人",
  ownersLine: "负责人：{{names}}",
  // Kind filter and several-at-once Catchy (Jay tasks #1117 / #1120, 31/10)
  kindAll: "全部类型",
  bulkSelected: "已选 {{n}} 个",
  bulkOn: "为 Catchy 开启",
  bulkOff: "为 Catchy 关闭",
  bulkClear: "清除选择",
  bulkAll: "选择所有你可开关的文档",
  bulkNotYours: "只有此文件夹的负责人和管理员可以开关",
  bulkOnTitle: "为 Catchy 开启 {{n}} 个文档？",
  bulkOffTitle: "为 Catchy 关闭 {{n}} 个文档？",
  bulkWill: "将被处理",
  bulkSkip: "跳过",
  bulkNone: "所选文档中没有可开关的文档。",
  bulkDoneOn: "已为 Catchy 开启：{{n}} 个。",
  bulkDoneOff: "已为 Catchy 关闭：{{n}} 个。",
  bulkSkipped: "跳过 {{n}} 个：{{list}}。",
  skip_folder: "不是你的文件夹",
  skip_noversion: "尚未上传版本",
  skip_on: "已开启",
  skip_off: "已关闭",
  skip_missing: "未找到",
  langsDiffer: '请为每个文件选择不同的语言。',
  langBar: '文档语言',
  sideBySide: '并排阅读',
  fileN: '文件 {{n}}',
  leftLang: '左侧语言',
  rightLang: '右侧语言',
  mainFile: '主文件',
  langOf: '{{name}} 的语言',
  langReading: '读取中…',
  langPick: '选择语言',
  howText: '从内容识别',
  howName: '根据文件名',
  removeFile: '移除 {{name}}',
  addLangFile: '添加其他语言',
  pickFiles: '选择文件',
  langNote: "最多 8 个文件，每个 30 MB，仅限门户语言：Tiếng Việt、English、한국어、中文。同一语言的两个文件将成为文档的各部分，以标签页阅读。语言从文件内容读取，上传前请确认。第一个文件为主文件。",
  langsMissing: '请为每个文件选择语言。',
  langFileFailed: '版本 {{label}} 已保存，但未能添加 {{name}}：{{error}}',
  download: '下载',
  downloadTitle: '下载当前显示的版本和语言 — 副本标有版本号及“请在 HEVN Portal 查看最新版本”',
  downloaded: '已下载',
  tooBig: "{{name}} 为 {{mb}} MB — 每个文件上限 {{max}} MB。",
  serverTooBig: "文件超过服务器上限 — 每个文件最多 {{mb}} MB。",
  partN: "第 {{n}} 部分",
  partsNote: "{{lang}} 共 {{n}} 个文件：将作为文档的各部分，以标签页阅读。",
  partBar: "文档各部分",
  addFile: "添加文件",
  kindChange: "改为 {{code}}",
  kindHint: "{{old}} 将获得新类型的下一个编号（{{code}}）；{{old}} 及旧链接仍可打开。所有被分享的人都会收到邮件和铃铛通知。",
  kindChanged: "类型已更改：{{old}} 现为 {{code}}。已通知 {{n}} 位被分享的人。",
  formerly: "原编号 {{codes}}",
  kindChoose: "请选择类型",
  authorChoose: "请选择作者",
  fixVersion: "版本",
  fixVersionHint: "当前版本号，以文档中写明的为准（例如 v2.1）。下次上传将从此编号继续。",
  kindAbout_HB: "手册 — 公司的运作方式：每个人都应了解的规则和工作方式。",
  kindAbout_GTM: "框架 — 一种模型或框架，例如上市策略。",
  kindAbout_CAT: "分类 — 产品或项目的分组与分类方式。",
  kindAbout_ANN: "公告 — 发给员工的带日期的通知。",
  kindAbout_POL: "政策 — 必须遵守的规定：允许什么、由谁决定。",
  kindAbout_SOP: "SOP — 某项工作的分步操作流程。",
  kindAbout_MAN: "手册与说明 — 系统、工具或产品如何使用。",
  kindAbout_RPT: "报告 — 某一期间的结果或数据。",
  kindAbout_FRM: "表单与模板 — 待填写的空白表格。",
  kindAbout_DOC: "其他 — 仅在以上类型都不适用时使用。",
  folderChoose: "请选择文件夹",
};

const dictionary = { ns: 'xDoc', en, ko, vi, zh };

export default dictionary;
